import { render, staticRenderFns } from "./vas.vue?vue&type=template&id=66362600&"
import script from "./vas.vue?vue&type=script&lang=js&"
export * from "./vas.vue?vue&type=script&lang=js&"
import style0 from "./vas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vas.vue"
export default component.exports